import { Component, OnInit, Input, OnDestroy, Output, EventEmitter, ViewChild, AfterViewInit} from '@angular/core';

import { AppState } from '../../../core';
import { ScoutPoint } from '../../../core/models';
import { FesBaseComponent } from '../../../shared/components/fes-base.component';
import { ScoutTaskService } from '../../../core/services';
import { NgForm } from '@angular/forms';
import { timer } from 'rxjs';

@Component({
  selector: 'app-scout-point-error-calc',
  templateUrl: './scout-point-error-calc.component.html',
  styleUrls: ['./scout-point-error-calc.component.scss']
})
export class ScoutPointErrorCalcComponent extends FesBaseComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() scoutPoint : ScoutPoint
  @Input() scoutPoints : ScoutPoint[] = []
  @Input() showTitlebar : boolean = true
  @Input() isEditing : boolean = false

  @Output() editModeChanged = new EventEmitter<ScoutPointErrorCalcComponent>()
  @Output('editChange') editChange = new EventEmitter<NgForm>()
 
  @ViewChild('errorCalcForm') errorCalcForm: NgForm;
  
  readonly ErrorPrecisionFormat = '1.4-4'
  readonly ConstantPrecisionFormat = '1.2-4'
  

  constructor(appState : AppState, protected scoutTaskService : ScoutTaskService) {
    super(appState)
  }


  ngOnInit(): void {
  }


  ngAfterViewInit(): void {
    this.subscribe(this.errorCalcForm.statusChanges, status => this.formChanged() )
    this.subscribe(this.errorCalcForm.valueChanges, change => this.formChanged() )
  }


  ngOnDestroy() {
    this.destroy()
  }


  formChanged = () => {
    timer(0).subscribe(_=> this.editChange.emit(this.errorCalcForm) )
  }

  
  edit(bEdit:boolean=true) {
    if ( this.isEditing != bEdit ) {
      this.isEditing = bEdit
      this.editModeChanged.emit(this)
    }
  }


  onEdit() {
    this.edit(true)
  }

}

